module.exports = __webpack_public_path__ + "static/permissions-view-9d0c586f636cd67ce2385bf1521055f5.png";